import { ESTADO_PUBLICADA } from '../../../constants/publicaciones.js'
import createValidador from '../../hooks/createValidador'

const MAXIMO_DESCUENTO = 99
const FECHA = 10
const MAXIMO_DESCRIPCION = 1000

export const getEsquema = () => {
  const { Validador } = createValidador()

  return {
    titulo: Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': (
            <>
              Ups, te olvidaste de completar el título de tu publicación!
              <br />
              Asegúrate de tener un buen título así el comprador podrá encontrar rápidamente tu
              producto.
            </>
          )
        })
      }),
    descripcion: Validador.Kernel.string()
      .trim()
      .required()
      .max(MAXIMO_DESCRIPCION)
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': (
            <>
              Ups, te olvidaste de completar la descripción del producto! <br /> Asegúrate de tener
              una buena descripción así el comprador sabrá exactamente qué está comprando.
            </>
          ),
          'string.max': (
            <>La descripción es demasiado larga. El máximo permitido es de 1000 caracteres.</>
          )
        })
      }),
    desde: Validador.Kernel.date()
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'date.base': <>Ups, debe seleccionar la {'"Fecha Desde"'} </>
        })
      }),
    hasta: Validador.Kernel.date()
      .min(Validador.Kernel.ref('desde'))
      .min(new Date(Validador.fechaActual))
      .required()
      .error((e) => {
        return Validador.mensaje(e, {
          'date.base': <>Ups, debe seleccionar la {'"Fecha Hasta"'}</>,
          'date.min': (
            <>
              Ups, para guardar la publicación la {'"Fecha Hasta"'} debe ser mayor o igual a{' '}
              {'"Fecha Desde"'} y mayor o igual a la fecha actual.
            </>
          )
        })
      }),
    precioUnitario: Validador.Kernel.number()
      .empty(0)
      .min(1)
      .error((e) => {
        return Validador.mensaje(e, {
          'number.min': <>Ups, el Precio no puede ser 0</>,
          'any.required': <>Ups, el Precio no puede ser 0</>
        })
      }),
    cantDisponible: Validador.Kernel.when('apedido', {
      is: false,
      then: Validador.Kernel.number().required().min(0),
      otherwise: Validador.Kernel.allow(null, '').optional()
    }).error((e) => {
      return Validador.mensaje(e, {
        'number.min': <>Ups, la cantidad disponible no puede ser menor a 0</>,
        'any.required': <>Ups, debes completar la Cantidad Disponible</>,
        'number.base': <>Ups, la Cantidad Disponible debe ser un número válido</>
      })
    }),
    cantMinPedido: Validador.Kernel.when('apedido', {
      is: true,
      then: Validador.Kernel.number()
        .empty(0)
        .min(1)
        .required()
        .max(Validador.Kernel.ref('capacidadMax'))
    }).error((e) =>
      Validador.mensaje(e, {
        'any.empty': <>Ups, Cantidad Mínima de Pedido debe ser mayor a cero</>,
        'any.required': <>Ups, Cantidad Mínima de Pedido debe ser mayor a cero</>,
        'number.min': <>Ups, Cantidad Mínima de Pedido debe ser mayor a cero</>,
        'number.max': (
          <>ups, Cantidad Máxima de Pedido debe ser menor o igual a la cantidad máxima</>
        )
      })
    ),
    capacidadMax: Validador.Kernel.when('apedido', {
      is: true,
      then: Validador.Kernel.number()
        .empty(0)
        .min(1)
        .min(Validador.Kernel.ref('cantMinPedido'))
        .required()
    }).error((e) =>
      Validador.mensaje(e, {
        'any.empty': <>Ups, Cantidad Máxima debe ser mayor a cero</>,
        'any.required': <>Ups, Cantidad Máxima debe ser mayor a cero</>,
        'number.min': <>Ups, Cantidad Máxima debe ser mayor o igual a la Cantidad Mínima</>
      })
    ),
    cantTiempoProd: Validador.Kernel.when('apedido', {
      is: true,
      then: Validador.Kernel.number().empty(0).min(1).required()
    }).error((e) =>
      Validador.mensaje(e, {
        'any.empty': <>Ups, Tiempo de Producción debe ser mayor a cero</>,
        'any.required': <>Ups, Tiempo de Producción debe ser mayor a cero</>,
        'number.min': <>Ups, Tiempo de Producción debe ser mayor a cero</>
      })
    ),
    periodoTiempoProd: Validador.Kernel.when('apedido', {
      is: true,
      then: Validador.Kernel.number().empty(0).required()
    }).error((e) =>
      Validador.mensaje(e, {
        'any.empty': <>Ups, debe seleccionar la unidad del Tiempo de Producción</>,
        'any.required': <>Ups, debe seleccionar la unidad del Tiempo de Producción</>
      })
    ),
    alicuota: Validador.Kernel.number()
      .empty(null)
      .required()
      .min(0)
      .max(100)
      .error((e) => {
        return Validador.mensaje(e, {
          'any.empty': <>Ups, debe seleccionar una alícuota</>,
          'any.required': <>Ups, debe seleccionar una alícuota</>,
          'number.min': <>Ups, la alícuota no puede ser negativa</>,
          'number.max': <>Ups, la alícuota no puede ser mayor a 100</>
        })
      }),
    porcDcto: Validador.Kernel.number()
      .integer()
      .min(0)
      .max(MAXIMO_DESCUENTO)
      .error((e) => {
        return Validador.mensaje(e, {
          'number.min': <>Ups, el {'"Porcentaje de descuento"'} es incorrecto</>,
          'number.max': <>Ups, el {'"Porcentaje de descuento"'} es incorrecto</>,
          'number.integer': <>Ups, el {'"Porcentaje de descuento"'} debe ser un número entero</>
        })
      }),
    ofertaDesde: Validador.Kernel.when('porcDcto', {
      is: 0,
      then: Validador.Kernel.date().allow(null).empty(''),
      otherwise: Validador.Kernel.date().empty('').min(new Date(Validador.fechaActual)).required()
    })
      .empty(null)
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe seleccionar {'"Fecha de Inicio"'}</>,
          'date.base': <>Ups, debe seleccionar una fecha válida de inicio</>,
          'date.min': <>Ups, la {'"Fecha de Inicio"'} no puede ser anterior a la fecha actual</>
        })
      }),
    ofertaHasta: Validador.Kernel.when('porcDcto', {
      is: 0,
      then: Validador.Kernel.date(),
      otherwise: Validador.Kernel.date()
        .min(Validador.Kernel.ref('ofertaDesde'))
        .max(Validador.Kernel.ref('hasta'))
        .required()
    })
      .empty(null)
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debe seleccionar {'"Fecha de Finalización"'}</>,
          'date.min': (
            <>
              Ups, la {'"Fecha de Finalización"'} no puede ser anterior a la
              {'"Fecha de Inicio"'}
            </>
          )
        })
      }),
    mediosPagos: Validador.Kernel.when('sinCondicionesDeVenta', {
      is: true,
      then: Validador.Kernel.any().optional(),
      otherwise: Validador.Kernel.array()
        .required()
        .min(1)
        .error((e) =>
          Validador.mensaje(e, {
            'array.base': <>Debe seleccionar al menos un medio de pago</>,
            'any.required': <>Debe seleccionar al menos un medio de pago</>,
            'array.min': <>Debe seleccionar al menos un medio de pago</>
          })
        )
    }),
    mediosEnvios: Validador.Kernel.when('sinMediosDeEnvio', {
      is: true,
      then: Validador.Kernel.any().optional(),
      otherwise: Validador.Kernel.array()
        .required()
        .min(1)
        .error((e) =>
          Validador.mensaje(e, {
            'array.base': <>Debe seleccionar al menos un medio de envío</>,
            'any.required': <>Debe seleccionar al menos un medio de envío</>,
            'array.min': <>Debe seleccionar al menos un medio de envío</>
          })
        )
    }),
    cantDiasRetiroComprador: Validador.Kernel.when('tieneRetiro', {
      is: true,
      then: Validador.Kernel.number().min(0).required(),
      otherwise: Validador.Kernel.allow(null, '').optional()
    }).error((e) => {
      return Validador.mensaje(e, {
        'any.required': <>Ups, debes completar los días de retiro</>,
        'number.min': <>Ups, la cantidad de días de retiro no puede ser menor a 0</>,
        'number.base': <>Ups, la cantidad de días de retiro debe ser un número válido</>
      })
    }),
    cantDiasEnvioGratis: Validador.Kernel.when('tieneEnvioGratis', {
      is: true,
      then: Validador.Kernel.number().min(0).required(),
      otherwise: Validador.Kernel.allow(null, '').optional()
    }).error((e) => {
      return Validador.mensaje(e, {
        'any.required': <>Ups, debes completar los días de envío gratis</>,
        'number.min': <>Ups, la cantidad de días de envío gratis no puede ser menor a 0</>,
        'number.base': <>Ups, la cantidad de días de envío gratis debe ser un número válido</>
      })
    }),
    descZona: Validador.Kernel.string()
      .trim()
      .when('tieneEnvioGratis', {
        is: true,
        then: Validador.Kernel.required(),
        otherwise: Validador.Kernel.allow(null, '')
      })
      .error((e) => {
        return Validador.mensaje(e, {
          'any.required': <>Ups, debes completar las zonas de envío gratis</>,
          'any.empty': (
            <>
              Ups, te olvidaste de completar las zonas con envío gratis! <br />
              Asegúrate de completar este campo para que el comprador sepa a qué zonas realizas
              envíos gratis.
            </>
          ),
          'string.base': <>Ups, las zonas de envío gratis deben ser un texto válido</>
        })
      }),
    idPublicacionEstado: Validador.Kernel.when('hasta', {
      is: Validador.Kernel.date().greater(new Date().toISOString().slice(0, FECHA)),
      then: Validador.Kernel.number()
        .required()
        .error((e) => {
          return Validador.mensaje(e, {
            'any.required': <>Ups, debe seleccionar un estado de publicación</>,
            'number.base': <>Ups, debe seleccionar un estado válido</>
          })
        }),
      otherwise: Validador.Kernel.when('hasta', {
        is: Validador.Kernel.date().less(new Date().toISOString().slice(0, FECHA)),
        then: Validador.Kernel.number()
          .required()
          .invalid(ESTADO_PUBLICADA)
          .error((e) => {
            return Validador.mensaje(e, {
              'any.required': <>Ups, debe seleccionar un estado de publicación</>,
              'number.base': <>Ups, debe seleccionar un estado válido</>,
              'any.invalid': (
                <>
                  Ups, antes de publicar debes actualizar la fecha de vigencia hasta a una fecha
                  futura
                </>
              )
            })
          }),
        otherwise: Validador.Kernel.number()
          .required()
          .error((e) => {
            return Validador.mensaje(e, {
              'any.required': <>Ups, debe seleccionar un estado de publicación</>,
              'number.base': <>Ups, debe seleccionar un estado válido</>
            })
          })
      })
    })
  }
}
